import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import Autocomplete from '@mui/material/Autocomplete'
import { styled } from '@mui/material/styles'
import TextField from '@mui/material/TextField'
import { useTranslation } from 'react-i18next'
import FormInputBase from './FormInputBase'

const MuiTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: '3px',
    minWidth: 180,
    '& fieldset': { borderColor: theme.palette.secondary_80.main },
  },
}))

const FormAutocomplete = ({ itemProps, formProps = {}, inputConfig = {}, ...otherProps }) => {
  const {
    values,
    options,
    onSubmit,
    onInputChange,
    onFocus,
    inputBaseProps,
    onLoadMore,
    sx,
    endAdornment,
    inputComponent,
    variant,
    afterAutoComplete = () => null,
    onChange: onChangeParent,
    onEnter,
    ...otherInputConfig
  } = inputConfig || {}

  const { field: { ref, onChange, ...fieldProps } = {}, fieldState: { error } = {} } =
    formProps || {}

  const { disabled } = itemProps || {}
  const { label, ..._itemProps } = itemProps || {}

  const textFieldProps = {
    ...fieldProps,
    ...otherProps,
    ...otherInputConfig,
    ..._itemProps,
  }

  const { t } = useTranslation()

  return (
    <FormInputBase
      label={label}
      onSubmit={
        onSubmit
          ? () => {
              onSubmit(fieldProps.value)
            }
          : null
      }
      disabled={disabled}
      inputBaseProps={inputBaseProps}
    >
      <Autocomplete
        size="small"
        onFocus={onFocus}
        onChange={(_, newValue) => {
          if (onChange) {
            onChange?.(newValue)
          } else {
            onChangeParent?.(newValue)
          }
        }}
        onInputChange={(event, newInputValue, reason) => {
          onInputChange?.(event, newInputValue, reason)
        }}
        options={options}
        value={values}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        noOptionsText={t('errors.no_options')}
        renderInput={params => (
          <MuiTextField
            {...params}
            inputRef={ref}
            size="small"
            helperText={error ? error.message : null}
            error={!!error}
            sx={{ flex: 1, ...sx }}
            fullWidth
            variant={variant}
            placeholder={inputConfig.placeholder}
            onKeyDown={e => {
              if (e.key.toLowerCase() === 'enter') {
                onEnter?.()
              }
            }}
          />
        )}
        fullWidth
        popupIcon={<KeyboardArrowDownIcon />}
        ListboxProps={{
          role: 'list-box',
          sx: { maxHeight: 200 },
          onScroll: event => {
            const listboxNode = event.currentTarget

            if (listboxNode.scrollTop + listboxNode.clientHeight >= listboxNode.scrollHeight - 10) {
              onLoadMore?.()
            }
          },
        }}
        {...textFieldProps}
      />
      {afterAutoComplete?.()}
    </FormInputBase>
  )
}

export default FormAutocomplete
